import { render, staticRenderFns } from "./BtnConfirmarEmissaoPedido.vue?vue&type=template&id=071c2dc9&"
import script from "./BtnConfirmarEmissaoPedido.vue?vue&type=script&lang=js&"
export * from "./BtnConfirmarEmissaoPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports